export default "__VITE_ASSET__BZ1jb5De__"